import { query, } from "@lookiero/messaging";
import { translationKey } from "../../domain/translation/model/translationKey";
const VIEW_TRANSLATION_KEY_BY_LOCALE = "view_translation_key_by_locale";
const viewTranslationKeyByLocale = (payload) => ({
    ...query({ name: VIEW_TRANSLATION_KEY_BY_LOCALE }),
    ...payload,
});
const viewTranslationKeyByLocaleHandler = ({ domain }) => async ({ locale }) => translationKey({ domain, locale });
export { VIEW_TRANSLATION_KEY_BY_LOCALE, viewTranslationKeyByLocale, viewTranslationKeyByLocaleHandler, };
